export default __webpack_public_path__ + "static/media/Ballroll_00334.a63282ca.png";